import { SwitchBox } from '@bbkPricingPage/components/switch-box/switch-box';
import { type ActiveItemPrice } from '../plan-customisation';

interface PlanSelectorProps {
  planPrices: ActiveItemPrice[];
  selectedPlanPrice: ActiveItemPrice;
  setSelectedPlanPrice: (planPrice: ActiveItemPrice) => void;
}

export const PlanSelector = ({
  planPrices,
  selectedPlanPrice,
  setSelectedPlanPrice,
}: PlanSelectorProps) => {
  const handleOnChange = (billingSystemId: string) => {
    const planPrice = planPrices.find(
      (planPrice) => planPrice.price.billing_system_id === billingSystemId
    );
    if (planPrice) {
      setSelectedPlanPrice(planPrice);
    }
  };

  if (!planPrices || planPrices.length <= 1) return null;

  const data = planPrices.map((planPrice) => ({
    id: `plan-${planPrice.price.billing_system_id}`,
    value: planPrice.price.billing_system_id,
    label:
      planPrice.item.customization.display_name ??
      planPrice.item.customization.name,
  }));

  return (
    <div className={'tw-mb-4'}>
      <SwitchBox
        id="plan-selector"
        data={data}
        onValueChange={handleOnChange}
        selectedValue={selectedPlanPrice.price.billing_system_id}
      />
    </div>
  );
};
